module.exports = __webpack_public_path__ + "img/simpli-icon.2e4eaf54.svg";